<template>
  <rect width="80" height="80" rx="40" fill="#F1F4F7" />
  <rect
    x="27.9042"
    y="17.8334"
    width="29.6268"
    height="39.4288"
    rx="0.233333"
    fill="#A3B1D1"
    stroke="#8497C2"
    stroke-width="0.466667"
    stroke-linejoin="round"
  />
  <rect
    x="26.1396"
    y="19.7549"
    width="30.0935"
    height="39.8954"
    rx="0.466667"
    fill="#DDE3F0"
  />
  <rect
    x="24.1333"
    y="21.75"
    width="30.0935"
    height="39.8954"
    rx="0.466667"
    fill="white"
  />
  <path
    d="M39.494 24.3102V19.5323C39.494 18.3135 40.8372 18.3135 40.8372 19.5323C40.8372 20.8609 40.8372 24.1759 40.8372 25.4787C40.8372 27.1071 37.6665 27.2038 37.6665 25.4787C37.6665 23.8938 37.6665 19.2905 37.6665 17.5782C37.6665 14.4052 42.1805 14.5884 42.1805 17.5782"
    stroke="#8497C2"
    stroke-width="0.466667"
    stroke-linecap="round"
  />
  <rect
    x="31.8706"
    y="28.7998"
    width="14.4667"
    height="1.4"
    rx="0.466667"
    fill="#8497C2"
  />
  <rect
    x="27.644"
    y="33.7183"
    width="23.0716"
    height="0.997386"
    rx="0.466667"
    fill="#D0D7E7"
  />
  <rect
    x="27.644"
    y="37.209"
    width="23.0716"
    height="0.997386"
    rx="0.466667"
    fill="#D0D7E7"
  />
  <rect
    x="27.644"
    y="40.7002"
    width="23.0716"
    height="0.997386"
    rx="0.466667"
    fill="#D0D7E7"
  />
  <rect
    x="27.644"
    y="44.1909"
    width="23.0716"
    height="0.997386"
    rx="0.466667"
    fill="#D0D7E7"
  />
  <rect
    x="27.644"
    y="47.6816"
    width="23.0716"
    height="0.997386"
    rx="0.466667"
    fill="#D0D7E7"
  />
  <rect
    x="43.6943"
    y="54.1646"
    width="7.02181"
    height="0.997386"
    rx="0.466667"
    fill="#A3B1D1"
  />
  <rect
    x="27.644"
    y="54.1646"
    width="7.02181"
    height="0.997386"
    rx="0.466667"
    fill="#A3B1D1"
  />
  <path
    d="M18.1606 61.9588L17.308 60.4822C17.0906 60.1055 17.6808 59.7648 17.8983 60.1414C18.1354 60.552 18.8729 61.8294 19.1053 62.2321C19.4734 62.8696 18.3902 63.495 18.0221 62.8574C17.7393 62.3676 16.772 60.6921 16.4664 60.1629C15.9003 59.1823 17.6417 58.3073 18.1752 59.2313C18.7732 60.2671 19.9655 62.3321 20.0321 62.4475C20.6982 63.6012 18.4086 64.7864 17.7841 63.7048C17.576 63.3442 16.514 61.5049 15.8856 60.4165"
    stroke="#F9FBFC"
    stroke-width="0.326667"
    stroke-linecap="round"
  />
  <path
    d="M62.1338 46.6705L63.1267 44.9806C63.38 44.5495 64.0555 44.9464 63.8022 45.3775C63.5261 45.8474 62.6672 47.3093 62.3965 47.7701C61.9678 48.4996 60.7282 47.7713 61.1568 47.0417C61.4862 46.4812 62.6128 44.5636 62.9686 43.958C63.628 42.8358 65.4906 44.0807 64.8693 45.1381C64.1728 46.3236 62.7843 48.6868 62.7067 48.8188C61.9309 50.1393 59.4473 48.5222 60.1747 47.2843C60.4171 46.8717 61.6539 44.7667 62.3857 43.5211"
    stroke="#DAE5F5"
    stroke-width="0.42"
    stroke-linecap="round"
  />
  <path
    d="M18.5278 26.0026L17.9355 24.6102C17.7844 24.255 18.341 24.0183 18.4921 24.3735C18.6568 24.7607 19.1691 25.9652 19.3306 26.3449C19.5863 26.946 18.5649 27.3805 18.3092 26.7794C18.1127 26.3175 17.4407 24.7375 17.2284 24.2385C16.8351 23.3138 18.4633 22.7302 18.8339 23.6015C19.2493 24.5782 20.0776 26.5255 20.1239 26.6343C20.5866 27.7222 18.4423 28.5202 18.0085 27.5002C17.8639 27.1602 17.1261 25.4257 16.6895 24.3994"
    stroke="#E5EAF4"
    stroke-width="0.233333"
    stroke-linecap="round"
  />
</template>
